
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/br/[tickerSymbol]",
      function () {
        return require("private-next-pages/br/[tickerSymbol]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/br/[tickerSymbol]"])
      });
    }
  